import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import {
  user,
  eye,
  dashboard,
  topAgents,
  agentList,
  account,
  pinpad,
  pos,
} from "@/modules";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  plugins: [
    createPersistedState({
      key: "readycash-report",
    }),
  ],
  mutations: {},
  actions: {},
  modules: {
    user,
    eye,
    dashboard,
    topAgents,
    agentList,
    account,
    pinpad,
    pos,
  },
});
